// router.tsx
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";

import Home from "./containers/Home";
import Error404 from "./containers/Error404";
import ProdInformation from "./containers/ProdInformation";
import Portfolio from "./containers/Portfolio";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<Home />} />
            <Route path="/portafolio" element={<Portfolio />} />
            <Route path="/portafolio/:productoSlug" element={<ProdInformation />} />
            <Route path="*" element={<Error404 />} />
        </>
    ),
    {
        future: {
            v7_startTransition: true, // <--- Activamos el flag
        },
    }
);